import styled from 'styled-components';
import { palette } from 'styled-theme';
import { WithDirection } from '@jjj/components';
import agencyPlaceholderSvg from '../../../assets/svg/agency-logo-placeholder.svg';

export const CompanyAvatarWrapper = styled('img')`
  margin: 0 10px;
  display: block;
  height: 40px;
  width: 40px;
  border-radius: 50%;
  position: absolute;
  bottom: 0;
  left: ${props => (props['data-rtl'] === 'rtl' ? '16px' : 'auto')};
  right: ${props => (props['data-rtl'] === 'rtl' ? 'auto' : '16px')};
`;

export const SmallCompanyAvatarWrapper = styled('img')`
  border-radius: 50%;
  height: 20px;
  margin: 0 10px;
  width: 20px;
  display: block;
`;

export const LoadMoreJobsBtnWrapper = styled('div')`
  .load-more-button {
    height: 40px !important;
    margin: 0;
    width: 100% !important;

    .load-more-button-icon {
      color: ${palette('success', 0)};
      margin-right: 6px;
    }
  }
`;

export const IconWrapper = styled('div')`
  background: ${palette('grayscale', 3)}
    url(${props => (props.$url && props.$url !== 'nophoto' ? props.$url : agencyPlaceholderSvg)}) no-repeat center
    center;
  background-size: cover;
  border-radius: 50%;
  height: 20px;
  width: 20px;
`;

export const VisibleIconsContainer = styled('div')`
  align-items: center;
  display: flex;
  max-width: 56px;
  position: relative;

  & > div:nth-child(2) {
    position: relative;
    right: 5px;
  }
`;

export const TooltipIconsContainer = styled('div')`
  display: flex;
  flex-direction: column;
`;

export const IconsContainer = styled('div')`
  display: flex;
`;

export const IconRowContainer = styled('div')`
  align-items: center;
  display: flex;
  margin-bottom: 5px;

  .icons-tooltip-agency-name {
    font-family: 'Helvetica';
    font-size: 10px;
    font-weight: 700;
    line-height: 11px;
    padding: 0 5px;
  }
`;

export const PlaceHolderContainer = styled('div')`
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  font-weight: 700;
`;

export const FirstNameCharacter = styled('div')`
  position: absolute;
`;

export const IconsBadgeWrapper = styled('div')`
  align-items: center;
  background: ${palette('secondary', 0)};
  border-radius: 50%;
  color: ${palette('grayscale', 5)};
  display: flex;
  font-family: 'Helvetica';
  font-size: 9px;
  font-weight: 700;
  height: 16px;
  justify-content: center;
  left: 46px;
  line-height: 10px;
  position: absolute;
  top: 13px;
  width: 16px;
`;

export const MaPauseStatusWrapper = WithDirection(styled('div')`
  .ma-pause-icon {
    color: ${palette('info', 0)};
    font-size: 15px;
    margin-left: ${props => (props['data-rtl'] === 'rtl' ? '5px' : '0')};
    margin-right: ${props => (props['data-rtl'] === 'rtl' ? '0' : '5px')};
    position: relative;
    top: 1px;
  }
`);
